import React from 'react';
import { useApp } from '../contexts/AppContext';
import { Button } from './ui/button';
import { translations, categories } from '../data/menuData';

export const CategoryFilter = ({ activeCategory, setActiveCategory }) => {
  const { language } = useApp();
  const t = translations[language];

  return (
    <div className="sticky top-[73px] z-40 bg-background/80 backdrop-blur-xl border-b border-border py-4">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-2">
          <Button
            onClick={() => setActiveCategory('all')}
            variant={activeCategory === 'all' ? 'default' : 'outline'}
            className={`rounded-full px-6 py-2 font-semibold whitespace-nowrap transition-all ${
              activeCategory === 'all'
                ? 'bg-foreground text-background hover:bg-foreground/90'
                : 'hover:bg-muted'
            }`}
            data-testid="category-all-btn"
          >
            {t.all}
          </Button>
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              variant={activeCategory === category.id ? 'default' : 'outline'}
              className={`rounded-full px-6 py-2 font-semibold whitespace-nowrap transition-all ${
                activeCategory === category.id
                  ? 'bg-foreground text-background hover:bg-foreground/90'
                  : 'hover:bg-muted'
              }`}
              data-testid={`category-${category.id}-btn`}
            >
              {category.title[language]}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};